import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExoStar } from 'src/app/models/ExoStar';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';
import { IMessagingSender, IMessaging, IMessagingReceived } from 'src/app/models/IMessaging';
import { Defaults } from 'src/app/Utilities/defaults';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service';
import { ILogicalAudit } from 'src/app/models/ilogical-audit';

export interface DialogData {
  associateUser: string;
  role: boolean;
  adminUser: string;
  screen: string;
  senderId: any;
  keychk: boolean;
  receiverid: string;
}

@Component({
  selector: 'app-associate-licensekey',
  templateUrl: './associate-licensekey.component.html',
  styleUrls: ['./associate-licensekey.component.css']
})
export class AssociateLicensekeyComponent implements OnInit {

  public associteUser: ExoStar;
  licensekeyform: FormGroup;
  submitted = false;
  Keys: ExoStar[];
  // public name: any;
  // public npi: any;
  // public nameid: any;
  public Lkey: string;
  public userId: string;
  public reciveruserId: string;
  public adminUser: string;
  public screen: string;
  public chkGrantacess: boolean = false;
  public chkDeaVald: boolean = false;
  licensekeydisableBtn: boolean = false;
  public AdminList: IUserDetails[];
  // ExoLicenseKey: ExoStar[]=[];
  IsAdmin: boolean = false;
  public chkkeys: boolean;
  public senderId: any;
  isDropDownkeyDisable: boolean = false;
  isDropDownadminDisable: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AssociateLicensekeyComponent>, private formBuilder: FormBuilder, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private activeserviceService: ActiveserviceService, private sharedService: SharedService
    , private messageService: MessagesService, private ExoStarServices: ExoStarService) {
    this.userId = data.associateUser;
    this.IsAdmin = data.role;
    this.adminUser = data.adminUser;
    this.screen = data.screen;
    this.senderId = data.senderId;
    this.chkkeys = data.keychk;
    this.reciveruserId = data.receiverid;
    this.getLicenseKeys();
    this.getAllAdmins();
    //this.getAssociateUserDetails(this.userId);
    // this.name = data.ExoLicenseKey.providerName;
    // this.npi = data.ExoLicenseKey.NPI;
    // this.nameid = data.ExoLicenseKey.providerId;
    // this.userId =data.ExoLicenseKey.userId;
    // this.fetchdata();
    if (this.chkkeys == true) {
      this.isDropDownkeyDisable = true;
    } else {
      this.isDropDownkeyDisable = false;
    }
  }

  ngOnInit() {
    this.licensekeyform = this.formBuilder.group({
      ProviderName: ['',],
      npinumber: ['',],
      licensekeys: ['', Validators.required],
      providerid: [''],
      dea: [''],
      epcsadmin: ['', Validators.required],
      Grant: [''],
      deaValid: [''],
    });
    this.getAssociateUserDetails(this.userId);
    //this.getLicenseKeys();
    //this.getAllAdmins()
    //this.fetchdata();
    if (this.screen == "Dashboard") {
      this.isDropDownkeyDisable = true;
      this.isDropDownadminDisable = true;
    }
    this.licensekeyform.markAllAsTouched();
    this.licensekeyform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.licensekeyform);
    });
  }
  getAllAdmins() {
    this.sharedService.getPracticeManagers(this.adminUser).subscribe(data => {
      this.AdminList = data;
    });
  }
  getLicenseKeys() {
    this.activeserviceService.getLicenseKeys().subscribe(result => {
      this.Keys = result;
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  fetchdata() {
    this.licensekeyform.patchValue({
      ProviderName: this.associteUser.providerName,
      npinumber: this.associteUser.NPI,
      providerid: this.associteUser.providerId,
      epcsadmin: this.associteUser.adminUserId,
      dea: this.associteUser.DEA,
      licensekeys: Number(this.associteUser.licenseKey) === 0 ? "" : Number(this.associteUser.licenseKey),
    });
    if (this.IsAdmin == false)
      this.onUserChange();
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }
  chkGrantAccess(event) {
    if (event.target.checked) {
      this.chkGrantacess = true;
      this.licensekeydisableBtn = false;
    }
    else {
      this.chkGrantacess = false;
      this.licensekeydisableBtn = true;
    }
  }
  chkDeaValid(event) {
    if (event.target.checked) {
      this.chkDeaVald = true;
      this.licensekeydisableBtn = false;
    }
    else {
      this.chkDeaVald = false;
      this.licensekeydisableBtn = true;
    }
  }
  onSubmit() {
    if (this.associteUser.DEA == null || this.associteUser.DEA == undefined || this.associteUser.DEA == '') {
      this.toastr.error("DEA Required");
      return;
    }
    if (this.IsAdmin) {
      if (!this.chkGrantacess && this.chkDeaVald) {
        this.toastr.error("Please check DEA and Grant");
        return;
      } else if (this.chkGrantacess && !this.chkDeaVald) {
        this.toastr.error("Please check DEA and Grant");
        return;
      }
      else if (this.chkGrantacess == false && this.chkDeaVald === false) {
        this.toastr.error("Please check DEA and Grant");
        return;
      }
      else if (this.associteUser.DEA == null || this.associteUser.DEA == undefined || this.associteUser.DEA == '') {
        this.toastr.error("DEA Required");
        return;
      }
    }
    var EpseObj: ExoStar = this.licensekeyform.value;
    if (this.data.keychk == true) {
      EpseObj.licenseKey = "";
    } else {
      EpseObj.licenseKey = this.licensekeyform.value.licensekeys;
    }
    EpseObj.adminUserId = this.licensekeyform.value.epcsadmin;
    if (this.chkGrantacess == true) {
      EpseObj.grantAccess = true;
    } else {
      EpseObj.grantAccess = false;
    }
    if (EpseObj != null && EpseObj != undefined) {
      if (this.data.receiverid != this.associteUser.adminUserId && this.screen == "Dashboard") {
        this.toastr.error("Processed by some other user");
        this.updateMessageStatus();
        this.dialogRef.close();
      }
      else {
        EpseObj.modifiedBy = sessionStorage.getItem("userId").toString();
        EpseObj.userId = this.userId;
        this.ExoStarServices.updateExoStarUserLicenseKey(EpseObj).subscribe(
          results => {
            this.toastr.success(results);
            if (this.screen == "EPCS" && EpseObj.grantAccess == false)
              this.sendRequestMessage();
            else if (this.screen == "Dashboard")
              this.sendResponseMessage();
            else {
              this.sendMessagetoRegistrant();
            }
            this.dialogRef.close(EpseObj);
          }, (err: any) => {
            console.log(err);
          });
      }
    } else {
      this.toastr.warning("Please Select License Key");
      return;
    }
  }
  formErrors = {
    'epcsadmin': '',
    'licensekeys': '',
    'Grant': '',
    'deaValid': '',
  };

  validationMessages = {
    'epcsadmin': {
      'required': 'epcsadmin Key is required.',
    },
    'licensekeys': {
      'required': 'licensekeys is required.'
    },
    'Grant': {
      'required': 'Grant Access is required.'
    },
    'deaValid': {
      'required': 'deaValid is required.'
    }
  };
  logValidationErrors(group: FormGroup = this.licensekeyform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  msgsender: IMessagingSender;
  messaging: IMessaging = new IMessaging;
  msgreceived: IMessagingReceived[] = [];
  roleId: any;
  msgSenderId: any;
  msgReceiverId: any;

  sendMessagetoRegistrant() {
    this.msgsender = new IMessagingSender();
    this.msgsender.senderUserID = sessionStorage.getItem("userId").toString();
    this.msgsender.receiverUserID = this.licensekeyform.value.epcsadmin;
    this.msgsender.subject = 'GRANT ACCESS'; //associate user
    this.msgsender.body = 'GRANT REQUEST';
    this.msgsender.messageType = Defaults.message_Type_grant;
    this.msgsender.isDeleted = false;
    this.msgsender.isVisible = false;
    this.msgsender.dbOpertion = "Insert";
    this.msgsender.createdBy = sessionStorage.getItem("userId");
    this.msgsender.createdOn = new Date;
    this.msgsender.messageName = "";
    this.msgsender.imageSource = "";
    this.msgsender.amendmentId = 0;
    this.msgsender.amendmentStatus = "";
    this.msgsender.attachmentName = "";
    this.msgsender.attachment = "";
    this.msgsender.listUsersCC = "";
    this.msgsender.toOrCC = "";
    this.MapValuesforReceiver(this.userId);
    this.auditLog = new ILogicalAudit();
    this.auditLog.AdminId = this.licensekeyform.value.epcsadmin;
    this.auditLog.providerId = this.userId;
    this.auditLog.msgType = 'GRANT ACCESS';
    this.auditLog.grantAccess = true;
    this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
    this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    this.InsertMessage();
  }

  sendRequestMessage() {
    this.MapValuesforSender('REQUEST');
    this.MapValuesforReceiver(this.licensekeyform.value.epcsadmin);
    this.InsertMessage();
  }
  sendResponseMessage() {
    this.MapValuesforSender('RESPONSE');
    this.MapValuesforReceiver(this.userId);
    this.InsertMessage();
  }
  public auditLog: ILogicalAudit;

  MapValuesforSender(requestType: any) {
    this.msgsender = new IMessagingSender();
    this.msgsender.senderId = 0;
    if (requestType == 'REQUEST') {
      this.msgsender.senderUserID = sessionStorage.getItem("userId").toString();
      this.msgsender.receiverUserID = this.licensekeyform.value.epcsadmin;
      // this.msgsender.listUsersTo = this.licensekeyform.value.epcsadmin;
      // this.msgsender.patName =  this.name; // get userid into this popup 
      this.msgsender.subject = this.userId; //associate user
      this.msgsender.body = 'GRANT REQUEST';
      this.msgsender.messageType = Defaults.message_Type_grant;
      this.auditLog = new ILogicalAudit();
      if (this.IsAdmin == true) {
        this.auditLog.AdminId = this.licensekeyform.value.epcsadmin;
        this.auditLog.providerId = this.userId;
      }
      else {
        this.auditLog.AdminId = sessionStorage.getItem("userId");
        this.auditLog.providerId = this.licensekeyform.value.epcsadmin;
      }
      this.auditLog.msgType = 'GRANT ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    }
    else {
      this.msgsender.subject = this.associteUser.adminUserId;
      this.msgsender.body = 'GRANT ACCESS';
      this.msgsender.senderUserID = this.associteUser.adminUserId;
      this.msgsender.messageType = Defaults.message_Type_finalizeGrant;
      this.msgsender.receiverUserID = this.userId;
      this.auditLog = new ILogicalAudit();
      this.auditLog.AdminId = this.associteUser.adminUserId;
      this.auditLog.providerId = this.userId;
      this.auditLog.msgType = 'GRANT ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    }

    this.msgsender.isDeleted = false;
    this.msgsender.isVisible = false;
    this.msgsender.dbOpertion = "Insert";
    this.msgsender.createdBy = sessionStorage.getItem("userId");
    this.msgsender.createdOn = new Date;
    this.msgsender.messageName = "";
    this.msgsender.imageSource = "";
    this.msgsender.amendmentId = 0;
    this.msgsender.amendmentStatus = "";
    this.msgsender.attachmentName = "";
    this.msgsender.attachment = "";
    this.msgsender.listUsersCC = "";
    this.msgsender.toOrCC = "";

  }

  msgreceiver: IMessagingReceived;
  MapValuesforReceiver(receiver: any) {
    this.msgreceiver = new IMessagingReceived;
    this.msgreceiver.listUsersTo = receiver;
    this.msgreceiver.receiverUserID = receiver;
    this.msgreceiver.receiverID = 0;
    this.msgreceiver.senderID = 0;
    this.msgreceiver.listUsersCC = "";
    this.msgreceiver.toOrCC = "";
    this.msgreceiver.roleID = this.roleId;
    this.msgreceiver.dbOpertion = "Insert";
    this.msgreceiver.isActive = false;
    this.msgreceiver.isVisible = false;
    this.msgreceiver.isDeleted = false;
    this.msgreceiver.createdBy = sessionStorage.getItem("userId");
    this.msgreceiver.createdOn = new Date;
    this.msgreceiver.attachmentName = "";
    this.msgreceiver.attachment = "";
    this.msgreceived.push(this.msgreceiver);
    this.msgreceiver = null;
  }

  result: string = "";
  InsertMessage() {
    this.messaging.messagingSenders = this.msgsender;
    this.messaging.lstmessagingReceiveds = this.msgreceived;
    this.messageService.insertSenderMessageDetails(this.messaging, sessionStorage.getItem("userId")).subscribe(data => {
      this.result = data;
      this.toastr.success(this.result);
      // insert logical access
      this.updateAuditLog();
      //inactivate message in dashboar
      this.updateMessageStatus();
    },
      (err: any) => {
        console.log(err)
        this.result = err;
        this.toastr.error(this.result);
      }
    );
  }

  onUserChange() {
    var user = this.AdminList.find(x => x.userId == this.licensekeyform.value.epcsadmin);
    if (user.roleName == 'ADMIN')
      this.IsAdmin = true;
    else
      this.IsAdmin = false;
  }


  getAssociateUserDetails(userId: any) {
    this.ExoStarServices.getExoStarAssociateDetails(userId).subscribe(
      results => {
        this.associteUser = results;
        this.fetchdata();
      }, (err: any) => {
        console.log(err);
      });
  }
  updateAuditLog() {
    //  update this.auditLog
    this.ExoStarServices.insertErxAuditLogDetails(this.auditLog).subscribe(
      results => {
      }, (err: any) => {
        console.log(err);
      });

  }

  updateMessageStatus() {
    if (this.senderId != null && this.senderId != undefined && this.senderId != '') {
      this.ExoStarServices.UpdateMessingSendbyId(this.senderId).subscribe(
        results => {
          this.dialogRef.close();
        }, (err: any) => {
          console.log(err);
        });
    }

  }
}
